module.exports = __webpack_public_path__ + "static/media/card_1.7a4cbb16.png";